export const BANKING_DETAILS_VERIFYING = 'advisor/BANKING_DETAILS_VERIFYING';
export const GET_ADVISORS_SUCCESS = 'advisors/GET_ADVISORS_SUCCESS';
export const GET_ADVISOR_SUCCESS = 'advisors/GET_ADVISOR_SUCCESS';
export const CREATE_ADVISOR_SUCCESS = 'advisors/CREATE_ADVISOR_SUCCESS';
export const UPDATE_ADVISOR_SUCCESS = 'advisors/UPDATE_ADVISOR_SUCCESS';
export const REMOVE_ADVISOR_SUCCESS = 'advisors/REMOVE_ADVISOR_SUCCESS';
export const GET_SPECIFIC_ADVISOR_ACCOUNTS_SUCCESS = 'advisors/GET_SPECIFIC_ADVISOR_ACCOUNTS_SUCCESS';

export const CREATE_ACCOUNT_SUCCESS = 'advisors/CREATE_ACCOUNT_SUCCESS';
export const REMOVE_NOTIFICATION_SUCCESS = 'advisors/REMOVE_NOTIFICATION_SUCCESS';

export const SET_AFFILIATE_LINK = 'advisors/SET_AFFILIATE_LINK';